import React from 'react'
import ReactSelect from '../../ReactSelect/ReactSelect'

const UnitesDropdown = ({units,onChange,isDisabled,defaultValue}) => {
    const options = (units || [])
      .map((unit) => {
        if (unit?.unit_type_for_name?.length > 0) {
          const defUnit = unit.unit_type_for_name.find(
            (u) => u.is_default_unit_for_type === true
          );
          if (defUnit) {
            return {
              value: unit.unit_type_id,
              label: defUnit.unit_name
            };
          }
        }
        return null;
      })
      .filter((option) => option !== null);
    
  return <>
    <ReactSelect
        options={options}
        onChange={(unit)=>{
          onChange((prev)=>{
            let updated = {...prev}
            if(unit){
              updated = {
                ...updated,
                unit_type_id_ref: unit.value,
                default_unit_show: unit.label,
                default_unit:unit.label
              }
            }else{
              updated = {
                ...updated,
                unit_type_id_ref:null,
                default_unit_show: '',
                default_unit:''
              }
            }
            return updated;
          })
        }}
        defaultValue={defaultValue}
        isDisabled={isDisabled}
      />
  </>
}

export default UnitesDropdown